export default {
  // data() {
  //   return {
  //     // 初始化条件
  //     pageInit: false
  //   }
  // },
  activated() {
    if (!this.$route.meta.useCatch) {
      //不用缓存的情况,首先清除之前缓存的数据然后再获取数据
      console.log('不用缓存的情况');
    } else {
      window.scroll(0, this.$store.state.scrollY) //还原页面滚动高度
      let self = JSON.parse(window.sessionStorage.self_select || '{}');
      console.log(self,self?.type==1 ?this.pageListAll : this.pageList,'========用缓存的情况')
      if(Object.keys(self).length==0) return;
      if(self?.type==1){// 主题
        this.pageListAll.forEach(item=>{
          if(self?.id?.includes(item.id)){
            item.optional = true
          }else if(self?.cancelId?.includes(item.id)){
            item.optional = false
          }
        })
      }else{ // 指数
        this.pageList.forEach(item=>{
          if(self?.id?.includes(item.indexCode)){
            item.isOptional = true
          }else if(self?.cancelId?.includes(item.indexCode)){
            item.isOptional = false
          }
        })
      }
     

    }
  },
  beforeRouteLeave(to, from, next) {
    // 默认返回首页清空缓存 ['/themeDetail','/publicHome']
    let pathList = ['/publicHome','/primaryHotList','/index','/assets']
    const sepicalTo = (
    (to.path==='/publicSurvival' && from.path === '/survivalDetail') 
    ||  (to.path==='/privateSurvival' && from.path === '/secondSurvival') 
    || (to.path==='/myChoice' && from.path === '/survivalDetail')
    ||  (to.path==='/secondSurvival' && from.path === '/primaryMarketDetail')
    ||  (to.path==='/primaryHotList' && from.path === '/primaryMarketDetail') 
    ||  (to.path==='/primaryAllProduct' && from.path === '/primaryMarketDetail')
    ||  (to.path==='/primaryHotList' && from.path === '/primaryAllProduct') 
    ||  (to.path==='/secondSurvival' && from.path === '/investmentRe') 
    
    ||  (to.path==='/investmentAnalysis' && from.path === '/secondSurvival') 
    ||  (to.path==='/assets' && from.path === '/investmentAnalysis') 
    ||  (to.path==='/privateSurvival' && from.path === '/investmentAnalysis') 
    );
    if (this.$route.meta && this.$route.meta.keepAlive && pathList.includes(to.path) || sepicalTo) {
      //清空缓存并且将缓存标记(useCatch)置位false
      let vnode = this.$vnode
      let parentVnode = vnode && vnode.parent;
      if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
        let key = vnode.key == null
          ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
          : vnode.key;//获取当前实例的key
        let cache = parentVnode.componentInstance.cache;//获取keep-alive中的缓存对象
        let keys = parentVnode.componentInstance.keys;//获取keep-alive中的key数组
        if (cache[key]) {
          this.$destroy()//销毁当前页面实例
          if (keys.length) {//删除当前页面的key
            let index = keys.indexOf(key)
            if (index > -1) {
              keys.splice(index, 1)
            }
          }
          cache[key] = null//删除当前页面缓存
        }
      }
      this.$route.meta.useCatch = false
    } else {
      if (this.$route.meta && this.$route.meta.keepAlive) {//判断原来是否用到keep-alive
        let position = window.scrollY //记录离开页面的位置
        if (position == null) position = 0
        this.$store.commit('changeRecruitScrollY', position)
        this.$route.meta.useCatch = true
      } else {
        return next()
      }
    }
    next()
  },
}